import { useEffect, useState } from 'react'
import { Button, CloseButton, Portal, Dialog, Box } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { FaInfoCircle } from 'react-icons/fa'
import { Article } from '@leid/api-articles'
import { getArticle } from 'app/serverActions/articles'
import ArticleContent from 'app/components/pages/articles/ArticleContent'
const articleId = 396 // https://leid.no/articles/396
export default function SafeWithLeidArticle() {
  const { t } = useTranslation('common')
  const [article, setArticle] = useState<Article | null>(null)
  const fetchData = async () => {
    if (articleId) {
      const articleResponse = await getArticle(articleId)
      setArticle(articleResponse)
    }
  }
  useEffect(() => {
    fetchData()
  }, [])

  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>
        <Button color="updatedLeid.green" padding="0" variant="plain" textDecoration="underline">
          {t('safeWithLeid')}
          <FaInfoCircle size={20} style={{ marginLeft: '2px', marginBottom: '10px' }} />
        </Button>
      </Dialog.Trigger>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content maxWidth="800px" width="calc(100% - 40px)">
            <Dialog.Body>
              <Box maxWidth="100%" marginX="auto" lineHeight="normal">
                {article && <ArticleContent article={article} />}
              </Box>
            </Dialog.Body>

            <Dialog.CloseTrigger asChild>
              <CloseButton size="2xl" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
